<template>
  <div class="container-fluid">
    <div class="row body-row">
      <div class="col-md-3 col-lg-2 p-0 d-md-block bg-dark">
        <nav-main></nav-main>
      </div>
      <div class="col-md-9 ms-sm-auto col-lg-10 pt-3 ">
        <my-breadcrumb></my-breadcrumb>
        <div class="restaurants">
          <div class="row my-3">
            <div class="col-12 home-statistics">
              <div v-show="this.LOADING.restaurants" class="spinner-border h4 fw-normal text-success" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <rest-statistic v-for="rest in RESTAURANTS" :rest="rest">
              </rest-statistic>
            </div>
          </div>
          <div class="row">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import router from "@/router";
import NavMain from './modules/NavMain'
import MyBreadcrumb from './modules/Breadcrumb'
import RestStatistic from "./statistics/HomeStatistics";
import axios from "axios";
export default {
  name: "Home",
  components: {NavMain, MyBreadcrumb, RestStatistic},
  computed: {
    ...mapGetters([
      'RESTAURANTS',
      'STATISTICS',
      'LOADING',
    ])
  },
  methods: {
  },
  mounted() {
    this.$store.dispatch('getRestaurants');
  }
}
</script>

<style scoped>

</style>
